import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.modal.penny_transfer.title',
        defaultMessage: 'Send us a penny'
    },
    subTitle: {
        id: '_.modal.penny_transfer.subTitle',
        defaultMessage:
            'To verify your business bank details, log on to your online banking and transfer us a penny to the following account:'
    },
    accountNumber: {
        id: '_.modal.penny_transfer.account_number',
        defaultMessage: 'Account number'
    },
    sortCode: {
        id: '_.modal.penny_transfer.sort_code',
        defaultMessage: 'Sort code'
    },
    accountName: {
        id: '_.modal.penny_transfer.account_name',
        defaultMessage: 'Account name'
    },
    business: {
        id: '_.modal.penny_transfer.business',
        defaultMessage: 'Business'
    },
    reference: {
        id: '_.modal.penny_transfer.reference',
        defaultMessage: 'Reference'
    },
    cancel: {
        id: '_.modal.penny_transfer.cancel',
        defaultMessage: 'Cancel'
    },
    fromYourAccount: {
        id: '_.modal.penny_transfer.from_your_account',
        defaultMessage: 'Single-bank transfer from your private account'
    },
    fromGuarantorAccount: {
        id: '_.modal.penny_transfer.from_guarantor_account',
        defaultMessage: `Single-bank transfer from the guarantor's private account`
    },
    sentPenny: {
        id: '_.modal.penny_transfer.sent_penny',
        defaultMessage: `I transferred a penny`
    },
    verifyingTitle: {
        id: '_.modal.penny_transfer.verifying.title',
        defaultMessage: `We're verifying the transaction`
    },
    verifyingSubTitle: {
        id: '_.modal.penny_transfer.verifying.subTitle',
        defaultMessage: `Thanks! Continue to the next step while we’re checking the transaction and we'll let you know once we've verified it.`
    },
    continue: {
        id: '_.modal.penny_transfer.verifying.continue',
        defaultMessage: 'Continue'
    }
});
